<template>
  <v-layout v-if="isRosterLoaded" row wrap pl-1 pr-1>
    <v-flex xs12 pa-2 text-xs-center>
      <h2 class="display-1">{{sectionLabel()}}</h2>
    </v-flex>
    <v-flex xs12 md6 lg4 xl3 v-for="(week, i) in roster" :key="i" ma-0 mt-0 pa-1>
      <v-card pa-0 class="caldendarDayCard">
        <v-card-title class="pa-0 cardTitle contentwrap" :class="setDayHeaderBg(week)">
          <v-layout row wrap>
            <v-flex xs7 pa-2 pl-3>
              <h3 class="headline">{{ dayLabel(week.day) }}</h3>
            </v-flex>
            <v-flex xs5 text-xs-right pa-2 v-if="week.needsAttention">
              <v-icon @click="openDayModal(week)" color="info" class="mt-1 mr-1" size=26 title="Needs Attention">
                error
              </v-icon>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text  class="contentwrap pa-0 ma-0">
          <v-layout row wrap pa-2>
            <v-flex xs12 pa-0 pl-2 ma-0>
              <p class="mb-0">
                <strong>Supervisor: </strong>
                <span v-if="week.data.supervisor !== null">{{getSupervisorName(week.data.supervisor, week.data.volunteers)}}</span>
                <span v-else><em>None Selected</em></span>
              </p>
            </v-flex>
            <v-flex xs12 pa-0 pl-2 ma-0>
              <p class="mb-0"><strong>Volunteers: </strong>{{week.data.volunteers.length}}</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text class="pa-0 ma-0 volunteerListWrap">
          <v-layout row wrap pa-0 ma-0 v-if="hasVolunteers(week)">
            <v-flex xs12 pt-1 pb-1 pl-3 pr-3 v-for="(volunteer, iii) in week.data.volunteers" :key="iii" class="volunteerListItem">
              <v-layout row wrap>
                <v-flex xs10>
                  <p class="pa-0 pt-1 ma-0">{{ volunteer.name }}</p>
                </v-flex>
                <v-flex xs2 text-xs-right>
                  <p v-if="dateIs(week.day) === 'future'"></p>
                  <p v-else-if="volunteer.attendance === undefined" class="ma-0">
                    <v-icon title="Requries Admin Confirmation of Attendance" color="info">help</v-icon>
                  </p>
                  <p v-else-if="volunteer.attendance" class="ma-0">
                    <v-icon color="success" title="Volunteer DID Attend">check</v-icon>
                  </p>
                  <p v-else class="ma-0">
                    <v-icon color="error" title="Volunteer DID NOT Attend">close</v-icon>
                  </p>
                  <!-- <v-btn depressed small fab color="error" title="This member wasn't in attendance today" class="confirmBtn">
                    <v-icon size=22>clear</v-icon>
                  </v-btn> -->
                </v-flex>
                <!-- <v-flex xs2 text-xs-right pr-4 pt-2>
                  <v-btn depressed small fab title="View This Members Details" class="confirmBtn" @click="gotoMember(volunteer.id, $event)">
                    <v-icon size=22>search</v-icon>
                  </v-btn>
                </v-flex> -->
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout v-else row wrap pa-0 ma-0>
            <v-flex xs12 pl-3 pt-2>
              <p>No Volunteers Scheduled</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text class="buttonWrap pa-3">
          <v-layout row wrap>
            <v-flex xs12 pa-0 pl-1 ma-0 text-xs-right>
              <v-btn @click="openDayModal(week)" title="Update roster details for this date" small depressed class="ma-0">
                 view details
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-dialog v-model="dayModal" width="600px" lazy :fullscreen="isMobile" persistent class="dayModal">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title class="pa-3 info">
              <v-layout row wrap pa-2 off>
                <v-flex xs12>
                  <h2 class="display-1 white--text">{{modalHeading}}</h2>
                </v-flex>
                <v-flex xs12>
                  <h3 class="subheading white--text">{{sectionLabel()}}</h3>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text  class="contentwrap pa-0 ma-0">
              <v-layout row wrap pa-2>
                <v-flex xs12 pa-0 pl-2 ma-0>
                  <p class="mb-0">
                    <strong>Supervisor: </strong>
                    <span v-if="modalSupervisorId !== null">{{modalSupervisorName}}</span>
                    <span v-else>None Selected <span class="error--text">* No Supervisor</span></span>
                  </p>
                </v-flex>
                <v-flex xs12 pa-0 pl-2 ma-0>
                  <p class="mb-0"><strong>Volunteers: </strong>{{modalVolunteerCount}} <span v-if="modalVolunteerCount <= 0" class="error--text">* No Volunteers Rostered</span></p>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text class="pa-0 ma-0 volunteerListWrap">
              <v-layout row wrap pt-2 pb-2 pl-3 pr-0 class="pa-0 cardTitle grey lighten-2">
                <v-flex xs8>
                  Volunteer Name
                </v-flex>
                <v-flex xs3 text-xs-right pr-0>
                  Attendance
                </v-flex>
              </v-layout>
              <v-layout row wrap pa-0 ma-0 v-if="modalVolunteers.length > 0">
                <v-flex xs12 v-for="(volunteer, iii) in modalVolunteers" :key="iii" class="volunteerListItem">
                  <v-layout row wrap>
                    <v-flex xs12 sm7 pt-1 pb-1 pl-3 pr-3>
                      <p class="pa-0 pt-1 ma-0">
                        <span v-if="volunteer.isCommittee || volunteer.isExecutive">
                          <v-icon class="pb-0 pr-0" size="20" title="Committee Member" color="blue">account_circle</v-icon>
                        </span>
                        <span v-if="volunteer.id === modalSupervisorId">
                          <v-icon class="pb-0 pr-0" size="20" title="Day Supervisor" color="purple">account_box</v-icon>
                        </span>
                        {{ volunteer.name }}
                      </p>
                    </v-flex>
                    <v-flex v-if="modalIsFutureDate" xs10 sm4 text-xs-right pt-1 pb-1 pl-3 pr-3>
                      <p class="ma-0 pt-1">--</p>
                    </v-flex>
                    <v-flex v-else-if="volunteer.attendance === undefined" xs10 sm4 pa-0 text-xs-right>
                      <p class="pl-2 ma-0 pt-2 float left">Did Attend?</p>
                      <v-btn @click="confirmAttendance(volunteer.id, true)" small depressed color="success" dark class="attendBtn ma-0 mr-1" title="This Person DID Attend their Rostered Track Duty">YES</v-btn>
                      <v-btn @click="confirmAttendance(volunteer.id, false)" small depressed color="error" dark class="attendBtn ma-0 ml-1" title="This Person DID NOT Attend their Rostered Track Duty">NO</v-btn>
                    </v-flex>
                    <v-flex v-else xs10 sm4 text-xs-right pa-0 ma-0>
                      <!-- <p class="ma-0">
                        <v-icon title="Requries Admin Confirmation of Attendance" color="info">help</v-icon>
                      </p> -->
                      <p v-if="volunteer.attendance" class="ma-0 success--text pt-2">
                        Attended
                      </p>
                      <p v-else class="ma-0 error--text pt-2">
                        Absent
                      </p>
                      <!-- <v-btn depressed small fab color="error" title="This member wasn't in attendance today" class="confirmBtn">
                        <v-icon size=22>clear</v-icon>
                      </v-btn> -->
                    </v-flex>
                    <v-flex xs1 text-xs-center mt-1>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">more_vert</v-icon>
                        </template>
                        <v-list>
                          <v-list-tile v-if="volunteer.id !== modalSupervisorId && (volunteer.isCommittee || volunteer.isExecutive)" @click="changeSupervisor(volunteer.id)">
                            <v-list-tile-title>Make Supervisor</v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile @click="removeFromRoster(volunteer.id)">
                            <v-list-tile-title>Remove From Roster</v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile v-if="volunteer.attendance !== undefined" @click="changeAttendance(volunteer.id)">
                            <v-list-tile-title>Change Attendance</v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 v-if="modalAddMemberToggle" class="volunteerListItem">
                  <v-layout row wrap>
                    <v-flex xs12 sm8 md6 pl-2>
                      <v-autocomplete
                        v-model="modalSetMember"
                        :items="modalAddMemberList"
                        :loading="modalMembersLoading"
                        item-text="name"
                        item-value="id"
                        label="Select a Member"
                      />
                    </v-flex>
                    <v-flex xs6 sm4 md4 pl-4>
                      <v-checkbox
                        v-model="modalSetMemberAsSupervisor"
                        label="Make Supervisor"
                        title="Mark this person as the day supervisor"
                      />
                    </v-flex>
                    <v-flex xs12 md2 text-xs-right pt-2>
                      <v-btn @click="addMemberToRoster()" :disabled="modalAddMemberValidate" fab small depressed style="min-width:30px; height:30px; width:30px;" title="Add Member to Roster">
                         <v-icon size="24">check</v-icon>
                      </v-btn>
                      <v-btn @click="modalAddMemberToggle = false; modalSetMember = null" fab small depressed style="min-width:30px; height:30px; width:30px;" title="Cancel New Member">
                         <v-icon size="24">close</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 v-if="modalAddMemberError" text-xs-right>
                      <span class="error--text pa-2 mr-2"><em>This member is already rostered</em></span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex v-show="!modalAddMemberToggle" xs12 pt-1 pb-1 pl-3 pr-3 class="volunteerListItem">
                  <v-layout row wrap>
                    <v-flex xs12 text-xs-right>
                      <v-btn @click="modalAddMemberToggle = true" :disabled="modalIsSaving" small depressed class="ma-0" title="Add Member to Days Roster">Add Member</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-layout row wrap justify-center>
                <v-flex v-if="modalSavingError" xs12 ma-0 pa-0 text-xs-center>
                  <p small class="red--text">There was an error saving your changes. Wait a few moments and try again.</p>
                </v-flex>
                <v-flex xs6 pr-2>
                  <v-btn
                    depressed
                    block
                    color=""
                    class=""
                    :disabled="modalIsSaving"
                    @click="closeDayModal()"
                  >Cancel</v-btn>
                </v-flex>
                <v-flex xs6 pl-2>
                  <v-btn
                    depressed
                    :loading="modalIsSaving"
                    :disabled="!modalUnsavedChanges"
                    block
                    color="success"
                    class="white--text"
                    @click="saveRoster()"
                  >Save Changes</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'MonthRoster',
  props: {
    currentYear: Number,
    currentMonth: Number
  },
  computed: {
    isMonthLoaded () {
      return !(this.data === null)
    },
    year () {
      if (this.currentYear !== undefined && this.currentYear !== null) return this.currentYear
      return null
    },
    month () {
      if (this.currentMonth !== undefined && this.currentMonth !== null) return this.currentMonth
      return null
    },
    isMobile () {
      return (window.innerWidth < 960)
    },
    ...mapGetters({
      members: 'getMembers',
      storeRoster: 'getRoster',
      isRosterLoaded: 'isRosterLoaded'
    }),
    modalAddMemberValidate () {
      return !(this.modalSetMember && this.modalSetMember !== null)
    },
    modalVolunteerCount () {
      return this.modalVolunteers.length
    },
    modalSupervisorName () {
      return this.getSupervisorName(this.modalSupervisorId, this.modalVolunteers)
    }
  },
  data () {
    return {
      currentDate: new Date().getDate(),
      roster: null,
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      dayModal: false,
      modalDate: null,
      modalHeading: null,
      modalSupervisorId: null,
      modalDateNotCompleted: false,
      modalVolunteers: [],
      modalSetMember: null,
      modalAddMemberToggle: false,
      modalAddMemberList: [],
      modalMembersLoading: false,
      modalSetMemberAsSupervisor: false,
      modalAddMemberError: false,
      modalUnsavedChanges: false,
      modalSavingError: false,
      modalIsSaving: false
    }
  },
  methods: {
    ...mapActions([
      'updateRosterDay',
      'getRosterMonth'
    ]),
    testalert () {
      alert('TEST THIS COMPONENT' + this.year + this.month)
    },
    getSupervisorName (supervisorId = null, volunteers = []) {
      if (volunteers.length === 0 || !supervisorId) return null
      let name = null
      for (var i = 0; i < volunteers.length; i += 1) {
        if (volunteers[i].id === supervisorId) name = volunteers[i].name
      }

      return name
    },
    gotoMember (userid, event) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      console.log('Goto User: ', userid)
      this.$router.push(`/admin/members/${userid}`)
    },
    sectionLabel: function () {
      const date = new Date(`${this.currentYear}`, `${this.currentMonth}`, 1)
      return `${this.months[date.getMonth()]}, ${date.getFullYear()}`
    },
    hasVolunteers: function (item) {
      try {
        if (!item.data.volunteers) return false
        if (item.data.volunteers.length > 0) return true
      } catch (e) {
        return false
      }
    },
    dateIs: function (date) {
      const today = new Date(new Date().toDateString())
      const day = new Date(new Date(date).toDateString())
      if (day <= today) return 'past'
      if (day === today) return 'present'
      if (day > today) return 'future'
      return 'past'
    },
    needsAttention: function (item) {
      // Attention Requirements:
      // Has Supervisor
      // Has Volunteers Rostered
      // Confirm Attendance of Volunteers for Finished Days
      try {
        if (item.supervisor === undefined || item.supervisor === null) return true
        if (!this.hasVolunteers(item)) return true
        if (this.dateIs(item.day) !== 'future') {
          let response = false
          for (var i = 0; i < item.data.volunteers.length; i += 1) {
            if (item.data.volunteers[i].completed === undefined) response = true
          }

          return response
        }
      } catch (e) {
        return false
      }
    },
    dayLabel: function (date) {
      let day = new Date(date)
      let suffix = 'th'
      if ([1, 21, 31].indexOf(date.getDate()) >= 0) suffix = 'st'
      if ([2, 22].indexOf(date.getDate()) >= 0) suffix = 'nd'
      if ([3, 23].indexOf(date.getDate()) >= 0) suffix = 'rd'
      return `${this.days[day.getDay()]} ${day.getDate()}${suffix}`
    },
    getMonth: function () {
      return this.months[this.month]
    },
    hasRoster: function (day) {
      if (this.roster !== undefined && this.roster !== null) {
        if (this.roster[day] !== undefined && this.roster[day] !== null) {
          return true
        }
      }
      return false
    },
    updateList: async function (params) {
      console.log('Updating Component Roster List')
      console.log(params)
      const list = []
      this.roster.map((item, ix) => {
        console.log(item)
        if (new Date(item.day).toDateString() !== new Date(params.date).toDateString()) {
          list.push(item)
        } else {
          item.data.supervisor = params.roster.supervisor
          item.data.volunteers = params.roster.volunteers
          list.push(item)
        }
      })
      this.roster = list
    },
    generateList: async function () {
      if (!this.isRosterLoaded) return null

      const roster = await this.getRosterMonth({ year: this.year, month: this.month })
      let newday = new Date(`${this.year}`, `${this.month}`, 1)
      // get the first day of next month.
      const firstDayNextMonth = new Date(this.year, this.month + 1, 1)
      const lastDayThisMonth = new Date(firstDayNextMonth - 1)
      const last = lastDayThisMonth.getDate()

      const list = []
      let now = new Date()
      for (var i = 1; i <= last; i += 1) {
        if (newday.getDay() === 0 || newday.getDay() === 6) {
          let item = new Date(newday)
          const daymeta = {
            day: item,
            completed: (item.toDateString() <= now.toDateString()),
            needsAttention: false,
            data: {
              supervisor: null,
              volunteers: []
            }
          }

          if (roster[item.getDate()] !== undefined) {
            daymeta.data = roster[item.getDate()]
          }
          if (daymeta.data.supervisor === undefined || daymeta.data.supervisor === null) {
            daymeta.needsAttention = true
          }
          if (daymeta.data.volunteers.length <= 0) {
            daymeta.needsAttention = true
          }
          if (this.dateIs(item.getDate()) !== 'future') {
            daymeta.data.volunteers.map(member => {
              if (member.attendance === undefined) {
                daymeta.needsAttention = true
              }
            })
          }

          list.push(daymeta)
        }
        newday.setDate(newday.getDate() + 1)
      }

      this.roster = list
      return true
    },
    loadMemberList: async function () {
      console.log('Processing Member List...')
      return this.members.map(member => {
        const item = {
          id: member.id,
          name: `${member.details.firstName} ${member.details.lastName}`
        }
        return Object.assign({}, item)
      })
    },
    setDayHeaderBg: function (item) {
      const today = new Date(new Date().toDateString())
      const day = new Date(new Date(item.day).toDateString())
      if (day === today) return 'blue'
      if (day > today) return ''

      return 'grey lighten-2'
    },
    openDayModal: async function (item) {
      /* #TODO: REMOVE TEST DATA WITH ACTIVE ROSTER DATA */
      this.modalDate = new Date(item.day)
      this.modalHeading = this.dayLabel(item.day)

      this.modalIsFutureDate = (this.dateIs(item.day) === 'future')

      this.modalVolunteers = JSON.parse(JSON.stringify(item.data.volunteers))
      this.modalAddMemberToggle = false
      if (this.modalAddMemberList.length <= 0) {
        this.modalMembersLoading = true
        console.log('Member List not populated yet')
        let list = await this.loadMemberList()
        console.log('List Generated!', list.length)
        this.modalAddMemberList = list
        this.modalMembersLoading = false
      }

      if (item.data.supervisor !== null) this.modalSupervisorId = item.data.supervisor
      this.modalSetMemberAsSupervisor = false
      this.modalUnsavedChanges = false
      this.dayModal = true
    },
    closeDayModal: function () {
      this.modalDate = null
      this.modalHeading = null
      this.modalVolunteers = []
      this.modalSupervisorId = null
      this.modalAddMemberToggle = false
      this.modalSetMember = null
      this.modalSetMemberAsSupervisor = false
      this.modalUnsavedChanges = false
      this.modalSavingError = false
      this.dayModal = false
    },
    confirmAttendance: function (memberId = null, attendance = false) {
      if (!this.modalVolunteers || !memberId) return false
      console.log('***CONFIRM ATTENDANCE***')
      console.log('Member ID', memberId)
      console.log('Attendance: ', attendance)

      const oldVolunteers = this.modalVolunteers || null
      console.log('Current Roster Day Volunteer List:')
      console.log(oldVolunteers)

      let newVolunteers = []

      oldVolunteers.forEach(member => {
        if (member.id === memberId) member.attendance = attendance
        newVolunteers.push(member)
      })

      this.modalVolunteers = newVolunteers
      console.log('Updated Modal Volunteers:')
      console.log(this.modalVolunteers)
      this.modalUnsavedChanges = true
    },
    retrieveMember: async function (memberId) {
      console.log('Searching for member...')
      let match = null
      this.members.map(member => {
        if (member.id === memberId) {
          console.log('Found retrievable member:')
          console.log(member)
          match = Object.assign({}, {
            id: member.id,
            isCommittee: (member.committee && member.committee.active),
            isExecutive: (member.executive && member.executive.active),
            name: `${member.details.firstName} ${member.details.lastName}`
          })
        }
      })

      return match
    },
    isMemberRostered: async function (memberId) {
      let isRostered = false
      this.modalVolunteers.map(member => {
        if (member.id === memberId) isRostered = true
      })
      return isRostered
    },
    addMemberToRoster: async function () {
      console.log('***ADD MEMBER TO ROSTER***')
      console.log('Member: ', this.modalSetMember)
      console.log('Set Member as Supervisor: ', this.modalSetMemberAsSupervisor)
      this.modalAddMemberError = false
      const member = await this.retrieveMember(this.modalSetMember)
      if (member === null) return false
      console.log('Found Member:', member)
      if (await this.isMemberRostered(member.id)) {
        console.log('THIS MEMBER IS ALREADY ROSTERED FOR THIS DAY')
        this.modalAddMemberError = true
        return false
      }
      this.modalVolunteers.push(member)
      if (this.modalSetMemberAsSupervisor) this.modalSupervisorId = member.id
      this.modalSetMember = null
      this.modalSetMemberAsSupervisor = false
      this.modalUnsavedChanges = true
    },
    changeSupervisor: async function (memberId) {
      this.modalSupervisorId = memberId
      this.modalUnsavedChanges = true
    },
    changeAttendance: async function (memberId) {
      let newRoster = this.modalVolunteers.map(member => {
        if (member.id === memberId) member.attendance = undefined
        return member
      })

      this.modalVolunteers = newRoster
      this.modalUnsavedChanges = true
    },
    removeFromRoster: async function (memberId) {
      let newRoster = []
      this.modalVolunteers.map(member => {
        if (member.id !== memberId) newRoster.push(member)
      })

      this.modalVolunteers = newRoster
      if (this.getSupervisorName(this.modalSupervisorId, this.modalVolunteers) === null) {
        this.modalSupervisorId = null
      }

      this.modalUnsavedChanges = true
    },
    saveRoster: async function () {
      if (this.modalIsSaving) return false
      this.modalIsSaving = true
      this.modalSavingError = false
      const date = new Date(this.modalDate)
      console.log('Creating New Roster Entry...')
      console.log('Updating Roster for: ', date)
      if (this.getSupervisorName(this.modalSupervisorId, this.modalVolunteers) === null) {
        this.modalSupervisorId = null
      }

      const params = {
        date,
        year: `${date.getFullYear()}`,
        month: `${date.getMonth()}`,
        day: `${date.getDate()}`,
        roster: {
          supervisor: JSON.parse(JSON.stringify(this.modalSupervisorId)),
          volunteers: JSON.parse(JSON.stringify(this.modalVolunteers))
        }
      }

      console.log('Current Year: ', params.year)
      console.log('Current Month: ', params.month)
      console.log('Current Day: ', params.day)
      console.log('Supervisor: ', params.roster.supervisor)
      console.log('Volunteers: ', params.roster.volunteers)

      // Save Roster To Backend
      const response = await this.updateRosterDay(params)
      if (response.error === undefined) {
        // Update Front End
        this.generateList()
        // Close Modal
        this.modalIsSaving = false
        this.closeDayModal()
        return true
      }

      this.modalIsSaving = false
      this.modalSavingError = true
    },
    async loadMonthRoster () {
      await this.generateList()
    }
  }
}
</script>
<style scoped>
.contentwrap {
  border-bottom: solid 1px lightgrey;
}
.cardTitle.attention {
  border-left: solid 10px orange;
}
.volunteerListWrap {
  min-height: 110px;
}
.volunteerListItem {
  border-bottom: solid 1px lightgrey;
}
.dayModal {
  min-width: 600px;
}
.attendBtn {
  margin-top:2px!important;
  min-width: 40px;
  height: 30px;
}

.caldendarDayCard .buttonWrap {
  opacity: 0;
  -webkit-transition: opacity .2s;
  transition: opacity .2s;
}

.caldendarDayCard:hover .buttonWrap {
  opacity: 1;
}
</style>
